import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-general",
  templateUrl: "./admin-add-general.component.html",
  styleUrls: ["./admin-add-general.component.css"],
})
export class AdminAddGeneralComponent implements OnInit {
  userCustomer: boolean = true;
  token: any;
  user_type: any = "corporate";
  type: any;
  perPage: any = 10;
  startPage: any = 1;
  customerMobile = -1;
  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private matdialogref: MatDialogRef<AdminAddGeneralComponent>
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    if (this.data.user_type === "customer") {
      this.userCustomer = false;
      this.user_type = "corporate";
    } else {
      this.userCustomer = true;
      this.user_type = "customer";
    }
  }
  Cancle() {
    this.matdialogref.close({ event: "Success" });
  }

  userTypeChanged() {
    this.loading = true;
    this.services
      .updateUserType(this.user_type, this.data._id, this.token)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.loading = false;
            this.matdialogref.close({ event: "Success" });

            let successMsg = "Updated successfully";
            if (response.body && response.body.message) {
              successMsg = typeof response.body.message === 'string' ? response.body.message : (response.body.message.message || successMsg);
            }

            this.snackBar.open(successMsg, "Success", { duration: 2000 });
            this.customerGet();
          }
          return;
        },
        (error) => {
          let errorMessage = "An error occurred";
          if (error.error && error.error.message) {
            errorMessage = error.error.message;
          } else if (typeof error === 'string') {
            errorMessage = error;
          } else if (error.message) {
            errorMessage = error.message;
          }

          if (
            errorMessage === "jwt malformed" ||
            errorMessage === "jwt expired" ||
            errorMessage === "invalid signature"
          ) {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          this.snackBar.open(errorMessage, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  customerGet() {
    this.services
      .getUsersCustomers(
        this.token,
        this.perPage,
        this.startPage,
        this.customerMobile
      )
      .subscribe(
        (response: any) => {
          const customerdata = response.body.data;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
